import React, { useState } from 'react';

export default function AdminRedisSection({ appId }) {
  const [expandedSections, setExpandedSections] = useState({
    upstash: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>⚡</span>
          <span>Redis</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Rate limiting via Upstash Redis
        </p>
      </div>

      <div className="space-y-4">
        <div className="border border-gray-200 rounded-lg">
          <button
            onClick={() => toggleSection('upstash')}
            className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
          >
            <h4 className="text-sm font-semibold text-gray-900">Upstash Redis</h4>
            <span className="text-gray-500 text-sm">
              {expandedSections.upstash ? '▼' : '▶'}
            </span>
          </button>
          {expandedSections.upstash && (
            <div className="p-4 pt-4 border-t border-gray-200 bg-gray-50">
              <div className="space-y-4 text-sm text-gray-700">
                <p className="text-xs text-gray-600">
                  Upstash provides serverless Redis used for API rate limiting and analytics. Each app gets its own Redis database to track request counts per API key or session.
                </p>

                <div>
                  <h5 className="font-semibold text-gray-900 mb-2">Environment Variables</h5>
                  <div className="space-y-1">
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">UPSTASH_REDIS_REST_URL</p>
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">UPSTASH_REDIS_REST_TOKEN</p>
                  </div>
                </div>

                <div>
                  <h5 className="font-semibold text-gray-900 mb-2">npm Packages</h5>
                  <div className="space-y-1">
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">@upstash/redis</p>
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">@upstash/ratelimit</p>
                  </div>
                </div>

                <div>
                  <a
                    href="https://console.upstash.com/redis?teamid=0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
                  >
                    Open Upstash Console →
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
